var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      [
        _c("guest-post-owner-info", {
          attrs: {
            user_data: _vm.data.owner,
            supplier_data:
              _vm.data.supplier !== null ? _vm.data.supplier : null,
            shared: _vm.data.newsfeed_type === "share" ? true : false,
            type: _vm.data.type,
            time: _vm.data.published_at,
          },
        }),
        _vm._v(" "),
        _vm.data.body !== null
          ? _c("div", [
              _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                staticClass: "breakAll mt-1 mr-1 ml-1",
                domProps: { innerHTML: _vm._s(_vm.data.body) },
              }),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          _vm.data.newsfeed_type === "share" ? "card mr-1 ml-1 mb-1 mt-0" : "",
        ],
      },
      [
        _vm.data.newsfeed_type === "share"
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-start" },
              [
                _c("guest-post-owner-info", {
                  attrs: {
                    user_data: _vm.data.original_newsfeed.owner,
                    supplier_data: _vm.data.original_newsfeed.supplier,
                    shared: false,
                    time: _vm.data.original_newsfeed.published_at,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Post"
          ? _c(
              "div",
              [_c("guest-newsfeed-post", { attrs: { data: _vm.data.module } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Video"
          ? _c(
              "div",
              [
                _c("guest-newsfeed-video", {
                  attrs: { data: _vm.data.module },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Resource"
          ? _c(
              "div",
              [
                _c("guest-newsfeed-resource", {
                  attrs: { data: _vm.data.module },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Event"
          ? _c(
              "div",
              [
                _c("guest-newsfeed-event", {
                  attrs: { data: _vm.data.module, plans: _vm.plans },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\ZoomWebinar"
          ? _c(
              "div",
              [
                _c("guest-newsfeed-zoom-webinar", {
                  attrs: { data: _vm.data.module, plans: _vm.plans },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Zoom"
          ? _c(
              "div",
              [_c("guest-newsfeed-zoom", { attrs: { data: _vm.data.module } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Job"
          ? _c(
              "div",
              [_c("guest-newsfeed-job", { attrs: { data: _vm.data.module } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Product"
          ? _c(
              "div",
              [
                _c("guest-newsfeed-product", {
                  attrs: { data: _vm.data.module },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.module_type === "App\\Models\\Stack\\Question"
          ? _c(
              "div",
              [
                _c("guest-newsfeed-question", {
                  attrs: { data: _vm.data.module },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.original_newsfeed != null
          ? _c("div", [
              _vm.data.original_newsfeed.group != null
                ? _c("div", { staticClass: "p-05" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/group/" + _vm.data.original_newsfeed.group.slug,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card text-white mb-0 border-0" },
                          [
                            _c("img", {
                              staticClass: "card-img img-fluid",
                              staticStyle: { height: "3rem" },
                              attrs: {
                                src:
                                  _vm.data.original_newsfeed.group
                                    .group_cover == null
                                    ? "/images/cover.jpg"
                                    : _vm.data.original_newsfeed.group
                                        .group_cover.url,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "text-white mb-0",
                                    staticStyle: { "line-height": "1rem" },
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.__("globals.posted_in")) +
                                          " "
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.data.original_newsfeed.group.title
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-sm btn-outline-white ml-auto",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.view_group")) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "feather icon-chevron-right",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.original_newsfeed.supplier != null
                ? _c("div", { staticClass: "p-05" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/supplier/" +
                            _vm.data.original_newsfeed.supplier.slug,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card text-white mb-0 border-0" },
                          [
                            _c("img", {
                              staticClass: "card-img img-fluid",
                              staticStyle: { height: "3rem" },
                              attrs: {
                                src:
                                  _vm.data.original_newsfeed.supplier
                                    .supplier_cover_image == null
                                    ? "/images/cover.jpg"
                                    : _vm.data.original_newsfeed.supplier
                                        .supplier_cover_image.url,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "text-white mb-0",
                                    staticStyle: { "line-height": "1rem" },
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.__("globals.posted_in")) +
                                          " "
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.data.original_newsfeed.supplier
                                            .title
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-sm btn-outline-white ml-auto",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.view_page")) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "feather icon-chevron-right",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.data.newsfeed_type === "share"
      ? _c("div", [
          _vm.data.group != null
            ? _c("div", { staticClass: "pl-1 pr-1 pb-05" }, [
                _c("a", { attrs: { href: "/group/" + _vm.data.group.slug } }, [
                  _c("div", { staticClass: "card text-white mb-0 border-0" }, [
                    _c("img", {
                      staticClass: "card-img img-fluid",
                      staticStyle: { height: "3rem" },
                      attrs: {
                        src:
                          _vm.data.group.group_cover == null
                            ? "/images/cover.jpg"
                            : _vm.data.group.group_cover.url,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "text-white mb-0",
                            staticStyle: { "line-height": "1rem" },
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.__("globals.posted_in")) + " "),
                            ]),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.data.group.title)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          { staticClass: "btn-sm btn-outline-white ml-auto" },
                          [
                            _vm._v(_vm._s(_vm.__("globals.view_group")) + " "),
                            _c("i", {
                              staticClass: "feather icon-chevron-right",
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data.supplier != null
            ? _c("div", { staticClass: "pl-1 pr-1 pb-05" }, [
                _c(
                  "a",
                  { attrs: { href: "/supplier/" + _vm.data.supplier.slug } },
                  [
                    _c(
                      "div",
                      { staticClass: "card text-white mb-0 border-0" },
                      [
                        _c("img", {
                          staticClass: "card-img img-fluid",
                          staticStyle: { height: "3rem" },
                          attrs: {
                            src:
                              _vm.data.supplier.supplier_cover_image == null
                                ? "/images/cover.jpg"
                                : _vm.data.supplier.supplier_cover_image.url,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "text-white mb-0",
                                staticStyle: { "line-height": "1rem" },
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.__("globals.posted_in")) + " "
                                  ),
                                ]),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.data.supplier.title)
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-sm btn-outline-white ml-auto",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.__("globals.view_page")) + " "
                                ),
                                _c("i", {
                                  staticClass: "feather icon-chevron-right",
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !(_vm.data.module_type === "App\\Models\\Stack\\Question")
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-between border-top p-05" },
          [
            _c(
              "div",
              {
                staticClass: "font-small-3 text-bold-700",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-thumbs-o-up" }),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.data.likesCount === 0 ? "" : _vm.data.likesCount
                    ),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "font-small-3 text-bold-700" }, [
              _c(
                "span",
                {
                  staticClass: "comment-button",
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-comment-o" }),
                  _vm._v(" "),
                  _vm.data.commentsCount === 1
                    ? _c("span", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.data.commentsCount),
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comment"))),
                      ])
                    : _c("span", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.data.commentsCount === 0
                                ? " "
                                : _vm.data.commentsCount
                            ),
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comments"))),
                      ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "font-small-3 text-bold-700" }, [
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-toggle",
                    attrs: {
                      id: "socialShareButton",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-share-alt" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("globals.share")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "socialShareButton" },
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.newsfeed_type === "share"
                            ? _vm.data.original_newsfeed.module.social
                            : _vm.data.module.social
                        ),
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }